import headshot from "../images/profile_3.jpeg";

export { headshot };

export const email = "mailto:hey@bithaiku.com?subject=Let%27s%20work%20together";
export const emailText = "hey@bithaiku.com";

export const tagline =
  "Bit Haiku is a small studio that builds custom software and AI automations for companies with better things to do than repetitive work.";

export const offerings = [
  {
    id: "01",
    title: "AI & automation",
    text: "The invoices, the inbox, the spreadsheet someone updates by hand every Monday. The hours spent manually inputting data from emails into systems. We find the repetitive work and build around it, with AI where it earns its place and a human check where it matters.",
    items: ["AI assistants & internal tools", "Document & data workflows", "Business system integrations"],
  },
  {
    id: "02",
    title: "Custom software",
    text: "Web and mobile applications shaped around how your business actually runs, from the first prototype to the version your customers rely on.",
    items: ["Web & mobile applications", "APIs & integrations", "Full-stack development"],
  },
  {
    id: "03",
    title: "Product & UX",
    text: "Before building, we work out what’s worth building. Research, interface design and the product decisions that keep a project small and useful.",
    items: ["Research & product strategy", "Experience & interface design", "Analytics & iteration"],
  },
];

export const steps = [
  { id: "01", label: "Understand", title: "Find the friction", text: "We conduct deep interviews to understand your business before writing code." },
  { id: "02", label: "Build", title: "Connect the pieces", text: "Your existing systems, traditional automation tools, plus AI where it actually helps." },
  { id: "03", label: "Iterate", title: "Measure and refine", text: "Quantify your results and tweak the system as needed." },
];

export const belief = {
  title: "Purpose before technology.",
  paragraphs: [
    "Every project starts with your business, not a tech stack. We look for the bottleneck, simplify what surrounds it, and build the smallest thing that removes it.",
    "We work closely with your team and ship code your next developer can read. Throughout our work, we keep security a top priority, not an afterthought.",
    "We’ve helped small and large companies in medical devices, financial services, manufacturing, and logistics.",
  ],
};

export const about = {
  name: "Tamas Erdos",
  role: "Founder",
  alt: "Tamas Erdos, founder of Bit Haiku",
  title: "Hi, I’m Tamas.",
  paragraphs: [
    "I founded Bit Haiku to help businesses turn complex challenges into simple, useful solutions.",
    "I’ve led innovation teams at startups, mid-sized businesses, and Fortune 500 companies. Now I lead a small team of developers and focus on getting the big picture right: product, process, and strategy.",
  ],
  cta: "Let’s talk about how you can move faster",
};

export const contact = {
  lines: ["A product idea. A process that takes too long.", "A question about whether AI could help.", "Send it over, even if it’s half-formed."],
};

export const socials = [
  { label: "GitHub", href: "https://github.com/erdostom" },
  { label: "Twitter", href: "https://twitter.com/tamas" },
  { label: "Privacy", href: "https://www.iubenda.com/privacy-policy/44877060" },
];

export const year = new Date().getFullYear();
